module.exports = __webpack_public_path__ + "img/markicon.8bd36e12.png";